/**
 * filterListReducer
 * slice reducer handling redux state variables storing the saved filter lists
 */

let initialState = {
  loadedLists: false,
  POIList: {},
  RatingBumpList: {},
  NewProspectsList: {},
  TrackedProspectsList: {},
  allPlayers: [],
  TrackedPlayers: [],
  hiddenPlayers: [],
  schoolUsersList: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_LOADED_LISTS':
      return Object.assign({}, state, {
        loadedLists: action.loadedLists,
      });
    case 'UPDATE_POI_FILTER_SET':
      return Object.assign({}, state, {
        POIList: action.POIList,
      });
    case 'UPDATE_RATING_BUMP_FILTER_SET':
      return Object.assign({}, state, {
        RatingBumpList: action.RatingBumpList,
      });
    case 'UPDATE_NEW_PROSPECTS_FILTER_SET':
      return Object.assign({}, state, {
        NewProspectsList: action.NewProspectsList,
      });
    case 'UPDATE_TRACKED_PROSPECTS_FILTER_SET':
      return Object.assign({}, state, {
        TrackedProspectsList: action.TrackedProspectsList,
      });
    case 'UPDATE_ALL_PLAYERS_LIST':
      return Object.assign({}, state, {
        allPlayers: action.allPlayers,
      });
    case 'UPDATE_SCHOOL_USERS_LIST':
      return Object.assign({}, state, {
        schoolUsersList: action.schoolUsersList,
      });
    case 'UPDATE_FILTERS':
      return Object.assign({}, state, {
        filters: action.filters,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/listReducer.js